import React from 'react';


const Code = ({ children }) => {
    return (
        <pre className="sm:m-4 m-2 p-2 my-6 bg-gray-200 dark:bg-gray-500 rounded boder text-xs">
            <code className="block whitespace-pre dark-text overflow-scroll">
                {children}
            </code>
        </pre>
    )
}

export default Code